const handleDeleteMaintenanceModal = {
  text1: 'Do you really want to delete this Maintenance?',
  text2: 'DELETE MAINTENANCE',
};

export default handleDeleteMaintenanceModal;
